import { toast } from 'react-toastify'

const toastControl = {
  _isShowing: false,

  show(message, options = {}) {
    if (!this._isShowing) {
      this._isShowing = true
      toast(message, {
        ...options,
        onClose: () => {
          this._isShowing = false
        }
      })
    }
  },

  showWarning(message) {
    this.show(message, { type: 'warning' })
  }
}

// Utilizado somente no api.js - FRE-618
export default toastControl
